export const staging_config = {
  apiKey: 'AIzaSyAlPxiRQ6kzbRCy7mkXSqJJ5jvc6h4ZOn0',
  authDomain: 'dashakswachhataka.firebaseapp.com',
  projectId: 'dashakswachhataka',
  storageBucket: 'dashakswachhataka.appspot.com',
  messagingSenderId: '684384337714',
  appId: '1:684384337714:web:90bb1704a27290c0efa12b',
  measurementId: 'G-FCTEEK73QB',
};
